const i2iInTitle = require('../i2iInTitle');

module.exports = titleText => {
  if (!titleText) return false;
  const title = document.createElement('h2');
  title.classList.add('ads__title');
  title.innerHTML = i2iInTitle(titleText);
  return title;
}
